import React from 'react';
import { article, ctaLabel, offerUrl, storyBlocks } from '../data/story';
export function StoryColumn() {
  return <article className="min-w-0 flex-1" data-id="element-44" data-mp="2cwbg0yb1dlmg">
      <blockquote className="border-l-[3px] border-purple-brand bg-cream px-4 py-3.5 font-article text-[15px] italic leading-relaxed text-neutral-700 sm:text-base" data-id="element-45" data-mp="2cx331kqkib14">
        {article.intro}
      </blockquote>

      <div className="mt-4" data-id="element-46" data-mp="2qv1fulp8pzei">
        {storyBlocks.map((block, index) => {
        if (block.kind === 'divider') {
          return <p key={`divider-${index}`} className="my-5 text-center font-ui text-[11px] italic tracking-[0.18em] text-purple-muted/70" data-id="element-47" data-mp="2vt2zb7qkw0qi">
                · · · {block.text} · · ·
              </p>;
        }
        if (block.kind === 'link') {
          return <p key={`link-${index}`} className="mb-3.5" data-id="element-48" data-mp="16dwhbj9fqs7w">
                <a href={offerUrl} target="_blank" rel="noopener noreferrer sponsored" className="font-article text-[15px] font-semibold leading-relaxed text-linkblue underline decoration-1 underline-offset-2 hover:text-purple-brand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-brand sm:text-base" data-id="element-49" data-mp="1ah1fj9mhg7qq">
                  {block.text}
                </a>
              </p>;
        }
        return <p key={`p-${index}`} className="mb-3.5 font-article text-[15px] leading-relaxed text-neutral-700 sm:text-base" data-id="element-50" data-mp="xmkgt8a9ws30" data-mpi={index}>
              {block.text}
            </p>;
      })}
      </div>

      <div className="my-6 lg:hidden" data-id="element-51" data-mp="17df32cnirrog">
        <a href={offerUrl} target="_blank" rel="noopener noreferrer sponsored" className="block w-full rounded-full bg-purple-brand px-5 py-3 text-center font-ui text-[13px] font-bold text-white shadow-[0_2px_6px_rgba(107,33,168,0.35)] transition-colors hover:bg-purple-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-brand" data-id="element-52" data-mp="17egrrjxgkcon">
          {ctaLabel}
        </a>
      </div>

      <footer className="mt-6" data-id="element-53" data-mp="myrgrvu5c0rh">
        <p className="font-article text-[16px] font-bold italic text-neutral-700" data-id="element-54" data-mp="rr0zaqsxlyjq">
          {article.signature}
        </p>
        <p className="mt-1 font-ui text-[11px] text-neutral-400" data-id="element-55" data-mp="wqne34oermun">
          {article.signatureTitle}
        </p>
      </footer>
    </article>;
}